import type { OptionalNumeric } from "~/util/string";

export enum MedicationForm {
    capsule = "capsule",
    cream = "cream",
    device = "device",
    drops = "drops",
    foam = "foam",
    gel = "gel",
    inhaler = "inhaler",
    injection = "injection",
    liquid = "liquid",
    lotion = "lotion",
    ointment = "ointment",
    patch = "patch",
    powder = "powder",
    spray = "spray",
    suppository = "suppository",
    tablet = "tablet",
    topical = "topical",
}

export const CountableMedicationForms = [
    MedicationForm.capsule,
    MedicationForm.drops,
    MedicationForm.patch,
    MedicationForm.tablet,
];

export const MedicationFormMap: Record<MedicationForm, string> = {
    [MedicationForm.capsule]: "Capsule",
    [MedicationForm.cream]: "Cream",
    [MedicationForm.device]: "Device",
    [MedicationForm.drops]: "Drops",
    [MedicationForm.foam]: "Foam",
    [MedicationForm.gel]: "Gel",
    [MedicationForm.inhaler]: "Inhaler",
    [MedicationForm.injection]: "Injection",
    [MedicationForm.liquid]: "Liquid",
    [MedicationForm.lotion]: "Lotion",
    [MedicationForm.ointment]: "Ointment",
    [MedicationForm.patch]: "Patch",
    [MedicationForm.powder]: "Powder",
    [MedicationForm.spray]: "Spray",
    [MedicationForm.suppository]: "Suppository",
    [MedicationForm.tablet]: "Tablet",
    [MedicationForm.topical]: "Topical",
};

export enum MedicationVolume {
    gram = "g",
    milligram = "mg",
    microgram = "mcg",
    milliliter = "ml",
    percent = "pc",
}

export const MedicationVolumeMap: Record<MedicationVolume, string> = {
    [MedicationVolume.gram]: "g",
    [MedicationVolume.milligram]: "mg",
    [MedicationVolume.microgram]: "mcg",
    [MedicationVolume.milliliter]: "ml",
    [MedicationVolume.percent]: "%",
};

export interface DosageData {
    form: MedicationForm;
    amount: OptionalNumeric;
    volume: MedicationVolume;
}
